/** Every sound effect by name (05 §2). Pure. */

import type { SoundId } from '../scan';
import type { Cue, UiSound } from '../types';
import { clock, doorOpen, expand, key, slime } from './deep';
import { born, died, explode, explodeButterfly, gateOpen, tick, timeout, won } from './drama';
import type { Sfx } from './kit';
import * as ui from './ui';
import { collect, dig, landBoulder, landDiamond, magicConvert, push } from './world';

export type { Sfx } from './kit';
export { amoebaBlip, magicTinkle, nextGap } from './ambient';
export { tickMidi } from './drama';
export { bonusTickMidi } from './ui';

export const SFX: Readonly<Record<SoundId, Sfx>> = {
  dig, collect, key, clock, landBoulder, landDiamond, push,
  explode, explodeButterfly, magicConvert, born, died, gateOpen, won,
  tick, timeout, doorOpen, expand, slime,
};

export const UI_SFX: Readonly<Record<UiSound, Sfx>> = {
  move: ui.move, select: ui.select, back: ui.back, error: ui.error, type: ui.type,
};

export const CUE_SFX: Readonly<Record<Cue, Sfx>> = {
  bonusLife: ui.bonusLife, bonusTick: ui.bonusTick, pause: ui.pause, resume: ui.resume, start: ui.start,
};
